<div [ngxTippy]="dialer_tooltip" tippyName="dialer_tooltip"
  [tippyProps]="{arrow: false, placement: 'bottom', maxWidth: 500, theme: 'dark'}">
  <button
    class=" dialer-button inline-flex items-center justify-center p-2 bg-transparent text-gray-700 hover:bg-gray-200 focus:outline-none;"
    [ngClass]="{
    'dialer-active': toggleOverlay,
    'invisible': !isDialerOverlayReady
  }" (click)="togglePanel(!toggleOverlay)" #dialerOrigin *ngIf="showDialerButton"
    [disabled]="currentUserStatus === 'BUSY'">
    <mat-icon [svgIcon]="dialerIcon"></mat-icon>
    @if(isAudioPermissionGiven){
      <span class="busy-dot-icon" *ngIf="currentUserStatus !== 'ONLINE'"></span>
    }@else {
      <mat-icon [svgIcon]="'tabler:microphone-off'" class="microphone-disabled-icon"></mat-icon>
    }
  </button>
</div>

<ng-template #dialer_tooltip let-hide>
  <div class="fade mx-auto w-auto max-w-96 h-auto tooltip text-white"
    *ngIf="this.integrations && this.integrations['zuperconnect']">
    <div class="py-2 flex items-center justify-start gap-3 tooltip-title">
      @if(isAudioPermissionGiven){<span class="busy-dot"></span>}
      @else {
       <span class="text-2xl text-red-500">
        <mat-icon [svgIcon]="'tabler:microphone-off'"></mat-icon>
       </span>
      }
      <p class="text-sm">
       {{ tooltipText }}
      </p>
    </div>
  </div>
</ng-template>